import { Paragraph } from "@tiptap/extension-paragraph";
import cn from "classnames";

import { getTableBeforeParagraph, checkIfLastNode } from "./util";

import "./style.scss";

const CustomParagraph = Paragraph.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            helpText: {
                default: false,
                parseHTML: (element) => element.classList.contains("help-text"),
            },
            hasComment: {
                default: false,
            },
            class: {
                default: undefined,
                renderHTML: (attributes) => {
                    return {
                        class: cn({
                            "help-text": attributes.helpText,
                            "has-comment": attributes.hasComment,
                        }),
                    };
                },
            },
            "data-diff-node": {
                default: undefined,
                renderHTML: (attributes) => {
                    return {
                        class: cn({
                            inserted: attributes["data-diff-node"] === "inserted",
                            deleted: attributes["data-diff-node"] === "deleted",
                        }),
                    };
                },
            },
            "data-diff-id": {
                default: undefined,
            },
        };
    },

    addKeyboardShortcuts() {
        return {
            ...this.parent?.(),
            // Needed to fix an issue when after un-setting a bullet list on the last paragraph of the page, and then clicking backspace again a paragraph is deleted
            // This solves the issue that when user clicks undo after the last paragraph is deleted an out of range selection error was thrown
            Backspace: ({ editor }) => {
                const { state } = editor;
                const { selection, doc } = state;
                const { empty, $anchor } = selection;

                if (!empty || $anchor.parentOffset !== 0) {
                    return false;
                }

                const paragraph = $anchor.parent.type.name === "paragraph" ? $anchor.parent : null;
                const isStandalone = $anchor.depth === 1;
                const isLastNode = checkIfLastNode(doc, paragraph, selection);
                const isEmpty = paragraph?.content.size === 0;

                if (!paragraph || !isStandalone || !isLastNode || !isEmpty) {
                    return false;
                }

                const table = getTableBeforeParagraph(doc, paragraph, selection);

                if (!table) {
                    return false;
                }

                return editor
                    .chain()
                    .command(({ tr }) => {
                        // Calculate table position
                        const tableStart = $anchor.before() - table.nodeSize;
                        const tableEnd = $anchor.before();

                        // Create selection for the entire table
                        tr.setSelection(
                            editor.state.selection.constructor.create(tr.doc, tableStart, tableEnd),
                        );
                        return true;
                    })
                    .run();
            },
        };
    },
});

export default CustomParagraph;
